module.exports = __webpack_public_path__ + "static/media/check-mark.a7005d21.svg";